
const login = require('./login')

export function start(detail, detailPrev){ 

  login.start(detail, detailPrev) 
  
      
}

